module.exports = __webpack_public_path__ + "img/wmsbonded.334462da.png";